import { createAction } from 'redux-actions';

export const resetOrderedItemsReport = createAction(
  'RESET_RESERVATION_ORDERED_ITEMS_REPORT'
);

export const updateOrderedItemsReportSearchQuery = createAction(
  'UPDATE_RESERVATION_ORDERED_ITEMS_REPORT_SEARCH_QUERY'
);
